module.exports = __webpack_public_path__ + "img/clock.b855bf8d.svg";